(function mpProjectSlide() {
  const isCompExists = GlobalSite.checkDependency('GlobalSite.isCompExists');
  const compName = 'mp_project-slide';
  const logFactory = GlobalSite.checkDependency('GlobalSite.logFactory');
  const Log = logFactory(`${compName}.js`);

  if (!isCompExists(compName, Log)) {
    return;
  }
  $(() => {
    $('#mp-project-slide__container').slick({
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: `<button class="slick-prev" type="button">
          <i class="i-arrow-left" aria-hidden="true"></i>
          <span class="slick-sr-only">Slide précédente</span>
          </button>`,
      nextArrow: `<button class="slick-next" type="button">
          <i class="i-arrow-right" aria-hidden="true"></i>
          <span class="slick-sr-only">Slide suivante</span>
          </button>`,
      infinite: false,
      dots: true,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 868,
          settings: {
            arrows: false,
          },
        },
      ],
      customPaging: (slider, i) =>
        $(
          `<button type="button">
          <span class="slick-dot-icon" aria-hidden="true" aria-label="Choisir une slide"></span>
          <span class="slick-sr-only">Aller vers la slide ${i + 1}"</span> 
        </button>`,
        ),
    });
  });
})();
